import { jsx } from "react/jsx-runtime";
const onClick = (e) => {
  window.open(e.currentTarget.href, "_blank");
};
const style = {
  cursor: "pointer"
};
const AnchorRenderer = (props) => /* @__PURE__ */ jsx(
  "a",
  {
    ...props.attributes,
    href: props.element.href,
    title: props.element.href,
    target: "_blank",
    rel: "noopener noreferrer",
    onClickCapture: onClick,
    style,
    children: props.children
  }
);
AnchorRenderer.displayName = "AnchorRenderer";
export {
  AnchorRenderer
};
//# sourceMappingURL=AnchorRenderer.js.map
